import React from "react";
import ForgotPasswordView from "./ForgotPasswordView";

const ForgotPasswordContainer = () => {
  return <ForgotPasswordView />;
};

export default ForgotPasswordContainer;
